import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import { TrackerProvider } from "@/lib/tracker";
import Dashboard from "@/components/Dashboard";
import Login from "@/components/Login";
import Landing from "@/components/landing/Landing";
import Privacy from "@/components/legal/Privacy";
import Terms from "@/components/legal/Terms";
import ResetPassword from "@/components/ResetPassword";
import AuthCallback from "@/components/AuthCallback";
import { Loader2 } from "lucide-react";

function Gate() {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="dark flex min-h-screen items-center justify-center bg-[#03050A] text-cyan-400">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    );
  }
  return user ? <Dashboard /> : <Landing />;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/" element={<Gate />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="dark App">
      <AuthProvider>
        <TrackerProvider>
          <BrowserRouter>
            <AppRouter />
            <Toaster position="top-right" theme="dark" />
          </BrowserRouter>
        </TrackerProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
